













































import {Component, Vue, Config, BasePage} from '@/common';
import customEdit from './components/customEdit.vue';
import {TwTable} from '@/components';

@Component({
	components: {
		customEdit
	}
})
export default class Order extends BasePage {
	get table(): TwTable {
		return this.$refs['table'] as TwTable;
	}

	rowGuid = '';
	showEdit = false;
	columns = [];

	searchMode = {
		CUSTOMNAME: ''
	};

	ok() {
		this.table.reload();
	}

	add() {
		this.rowGuid = '';
		this.showEdit = true;
	}

	refresh() {
		this.table.load({...this.searchMode});
	}

	dbClick(row) {
		this.showEdit = true;
		this.rowGuid = row.GUID;
	}

	deleteRows() {
		this.$confirm('此操作将永久删除该数据以及明细, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		})
			.then(() => {
				this.$http
					.post('Basic/Custom/Delete', {
						GUID: this.table.getSelections().map(item => item.GUID)
					})
					.then(res => {
						if (res.data.status === 0) {
							this.$message.success('删除成功');
							this.table.reload();
						} else {
							this.$message.warning(res.data.msg || '操作失败');
						}
					});
			})
			.catch(() => {
			});
	}

	mounted() {
		this.buildColumn('003001', this.columns);
	}

}
